import React, { Component } from 'react';
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";

export class Header extends Component {

  state = {
    loading: true
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 1000)
  }

  render() {
    return (
      <div>

        {/* Spinner Start */}
        {this.state.loading && (
          <div className="bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div className="spinner-grow text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
              <span>Loading...</span>
            </div>
          </div>
        )}
        {/* Spinner End */}

        {/* Navbar Start */}
        <div className="container-fluid sticky-top">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">

              <Link to="/" className="navbar-brand">
                <img src={logo} alt="logo" style={{ height: "50px" }} />
              </Link>

              <button
                type="button"
                className="navbar-toggler ms-auto me-0"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav mx-auto">

                  <Link to="/" className="nav-item nav-link active">Home</Link>
                  <Link to="/about" className="nav-item nav-link">About</Link>
                  <Link to="/services" className="nav-item nav-link">Services</Link>

                  {/* Dropdown Start */}
                  <div className="nav-item dropdown">
                    <Link 
                      to="#" 
                      className="nav-link dropdown-toggle" 
                      data-bs-toggle="dropdown"
                    >
                      Portfolio
                    </Link>

                    <div className="dropdown-menu bg-light mt-2">
                      <Link to="/case-studies" className="dropdown-item">
                        Case Studies
                      </Link>
                      <Link to="/portfolio" className="dropdown-item">
                        Portfolio
                      </Link>
                    </div>
                  </div>
                  {/* Dropdown End */}

                  <Link to="/contact" className="nav-item nav-link">Contact</Link>
                  <Link to="/blogs" className="nav-item nav-link">Blogs</Link>

                </div>
                    <Link className="btn btn-secondary px-3" to="/get_costing">Get Costing</Link>

              </div>

            </nav>
          </div>
        </div>
        {/* Navbar End */}

      </div> 
    )
  }
}

export default Header;